<template>
  <v-chip
    :color="tagColor"
    text-color="white"
    class="product-tag-chip"
    variant="elevated"
    size="x-small"
  >
    <v-icon start size="small" class="mr-1">mdi-tag</v-icon>
    {{ tagLabel }}
  </v-chip>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface ProductTag {
  name: string;
  hexColor: string;
  color?: string; // Added for backward compatibility
  // Add other properties your ProductTag has as needed
}

const props = defineProps({
  // Direct props for when we don't have a complete product tag object
  color: {
    type: String,
    default: "#1976D2",
  },
  label: {
    type: String,
    default: "",
  },
  // Full product tag object (optional)
  productTag: {
    type: Object as () => ProductTag | null,
    default: null,
  },
});

// Use values from productTag object if available, otherwise use direct props
const tagColor = computed(() => {
  if (props.productTag) {
    return props.productTag.hexColor || props.productTag.color;
  }
  return props.color;
});
const tagLabel = computed(() => props.productTag?.name || props.label);
</script>

<style scoped>
.product-tag-chip {
  font-weight: 500;
}
</style>
